
import { defineComponent } from "vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useI18n } from "vue-i18n";
import { Vue3Lottie } from "vue3-lottie";
import lottieAnimation from "@/assets/lottie-animations/payjoy_leaf_loader.json";

export default defineComponent({
  name: "OfferSignLoading",
  components: { Vue3Lottie },
  methods: { useAsset },
  emits: ["animationFinished"],
  props: {
    isTreatmentOneFunnel: Boolean,
  },
  data() {
    return {
      showText: false,
    };
  },
  created() {
    setTimeout(() => {
      this.showText = true;
      setTimeout(() => {
        this.$emit("animationFinished");
      }, 5500);
    }, 3000);
  },
  setup() {
    const { t } = useI18n();
    return { t, lottieAnimation };
  },
});
